import NpsByHourOfDayBarChart from './NpsByHourOfDayBarChart';
export default NpsByHourOfDayBarChart;



// WEBPACK FOOTER //
// ./src/components/NpsByHourOfDayBarChart/index.js